import { useParams, useNavigate, Link } from "react-router-dom";
import { ArrowLeft, Printer, ClipboardCheck } from "lucide-react";
import { useAdminGetAdmissionCardQuery } from "../../api/examsApi";
import ExamAdmissionCard from "../../components/ExamAdmissionCard";

export default function AdminExamAdmissionCardPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data, isLoading, isError } = useAdminGetAdmissionCardQuery(id!);

  const handlePrint = () => window.print();

  return (
    <>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { margin: 0; padding: 0; background: white; }
          #exam-admission-card {
            position: fixed; top: 0; left: 0; width: 210mm;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        }
      `}</style>

      <div className="p-6 space-y-6 bg-[#F8FAFC] min-h-screen">
        <div className="no-print flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="p-2 rounded-xl hover:bg-slate-200 transition-all"
            >
              <ArrowLeft className="w-4 h-4 text-slate-600" />
            </button>
            <div>
              <h1 className="text-lg font-black text-slate-900 uppercase tracking-widest">
                Admission Card — Admin View
              </h1>
              {data && (
                <p className="text-xs text-slate-400 font-bold uppercase tracking-widest">
                  {data.applicant?.name} &nbsp;·&nbsp; {data.applicant?.exam_no}
                </p>
              )}
            </div>
          </div>
          <Link
            to={`/exams/admin/applications/${id}/attendance-card`}
            className="flex items-center gap-2 px-5 py-2.5 bg-slate-700 text-white text-[10px] font-black uppercase tracking-widest rounded-xl hover:bg-orange-600 transition-all"
          >
            <ClipboardCheck className="w-4 h-4" />
            Attendance Card
          </Link>
          <button
            onClick={handlePrint}
            disabled={isLoading || isError}
            className="flex items-center gap-2 px-5 py-2.5 bg-slate-900 text-white text-[10px] font-black uppercase tracking-widest rounded-xl hover:bg-orange-600 transition-all disabled:opacity-50"
          >
            <Printer className="w-4 h-4" />
            Print Card
          </button>
        </div>

        {isLoading && (
          <div className="flex items-center justify-center py-20">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500" />
          </div>
        )}

        {isError && (
          <div className="bg-rose-50 border border-rose-200 rounded-2xl p-8 text-center">
            <p className="text-rose-700 font-black text-sm uppercase tracking-widest">
              Unable to load admission card.
            </p>
          </div>
        )}

        {data && (
          <div className="flex justify-center">
            <div className="shadow-2xl">
              <ExamAdmissionCard data={data} />
            </div>
          </div>
        )}
      </div>
    </>
  );
}
